import styled from 'styled-components';
import colors from '../../styles/colors';

export const Container = styled.div`
  background: linear-gradient(
    180deg,
    rgba(200, 200, 200, 0.3) 0%,
    rgba(240, 240, 240, 0.5) 100%
  );
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  height: 100vh;

  > img {
    max-height: 200px;
    margin-bottom: 2rem;
  }

  @media (max-width: 600px) {
    > img {
      height: auto;
      width: 180px;
    }
  }
`;

export const ShowPasswords = styled.div`
  display: flex;
  align-items: center;
  padding: 0 1rem;
  align-self: flex-start;
  transform: translateY(-16px);

  input {
    margin-right: 0.5rem;
  }
`;

export const Content = styled.div`
  min-width: 30%;
  max-width: 540px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: #fff;
  padding: 2rem;
  border-radius: 1rem;
  box-shadow: 1px 1px 2px rgba(0, 0, 0, 0.3);

  h1 {
    margin: 1rem 0;
    text-align: center;
  }

  h3 {
    text-align: center;
  }

  span {
    color: ${colors.aux1};
  }

  p {
    margin-top: 0.5rem;
    color: #ed4c4c;
  }

  img {
    width: 100px;
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 80%;
    gap: 1rem;
  }

  a {
    margin-top: 2rem;
    color: inherit;
    transition: all 0.2s;

    &:hover {
      color: ${colors.aux1};
    }
  }

  @media (max-width: 600px) {
    width: 90%;

    img {
      width: 80px;
    }

    form {
      width: 90%;
    }
  }
`;
